import {types, flow} from 'mobx-state-tree';
import * as api from '../../services/api';
// tslint:disable
const DOMAIL_EMAIL = '@ai.cohost.club';

const MailingListModel = types
  .model('MailingListModel', {
    address: types.maybe(types.string),
    name: types.maybe(types.string),
    description: types.maybe(types.string),
    botIncluded: types.maybe(types.boolean)
  })
  .actions((_self) => ({
    createMailingList: flow(function*(
      data: any,
      callback: (status: Number) => void
    ) {
      let {handleName, accessLevel, name, description, botIncluded} = data;
      let address = handleName.trim() + DOMAIL_EMAIL;
      botIncluded = botIncluded ? 'yes' : 'no';
      const response = yield api.createMailingList(
        address,
        accessLevel,
        botIncluded,
        name,
        description
      );
      if (typeof callback === 'function') {
        callback(response.status);
      }
    })
  }));

// export type MailingListType = Instance<typeof MailingListModel>;
export type MailingListType = typeof MailingListModel.Type;

export default MailingListModel;



// WEBPACK FOOTER //
// ./src/models/MailingListModel/MailingListModel.ts